export const EOSP = 1;
export const SOSP = 3;

// Adjust hours
export const ADJUST_HOURS = 148;
export const ADJUST_HOURS_DD = 201;
export const ADJUST_HOURS_MINUS_2H = 105;
export const ADJUST_HOURS_MINUS_15H = 106;
export const ADJUST_HOURS_MINUS_1H = 107;
export const ADJUST_HOURS_MINUS_05H = 108;
export const ADJUST_HOURS_PLUSS_2H = 109;
export const ADJUST_HOURS_PLUSS_15H = 110;
export const ADJUST_HOURS_PLUSS_1H = 111;
export const ADJUST_HOURS_PLUSS_05H = 112;

// IDL Crossing
export const IDL_CROSSING = 147;
export const IDL_CROSSING_DD = 199;
export const IDL_CROSSING_PLUSS_24H = 103;
export const IDL_CROSSING_MINUS_24H = 104;
